"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CTA() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="cta" ref={ref} className="relative py-20 md:py-28 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/cta_restaurant_blurred_background.png)]">
        <div className="absolute inset-0 bg-secondary/85"></div>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`max-w-3xl mx-auto text-center transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <h2 className="text-foreground-secondary font-display text-3xl sm:text-4xl md:text-5xl mb-4 leading-tight">
            Reserva una experiencia inolvidable en Playa del Carmen
          </h2>

          {}
          <p className="text-foreground-secondary/90 text-lg sm:text-xl mb-10">
            Mesas limitadas cada noche.
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button asChild className="bg-primary text-foreground-primary hover:bg-primary-hover hover:scale-105 shadow-medium px-8 py-6 text-base sm:text-lg font-semibold rounded-md transition-all duration-300">
              <Link to="https://wa.me/529841234567" newTab>
                Reservar por WhatsApp
              </Link>
            </Button>

            <Button asChild className="bg-secondary text-foreground-secondary hover:bg-secondary-hover hover:scale-105 shadow-medium px-8 py-6 text-base sm:text-lg font-semibold rounded-md transition-all duration-300 flex items-center gap-2">
              <Link to="tel:+529841234567">
                <Phone className="size-5" />
                Llamar ahora
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}